import { useGetPatientStudies } from '@/hooks/patients/useGetPatientStudies';
import { Alert, Typography } from '@mui/material';
import React from 'react';

export interface PatientStudiesAlertProps {
  patientId: number;
}

const PatientStudiesAlert: React.FC<PatientStudiesAlertProps> = ({ patientId }) => {
  const { data: studies, isLoading } = useGetPatientStudies({ size: 50 }, patientId);

  if (!isLoading && studies && studies.data?.length > 0) {
    return (
      <Alert severity={'warning'} aria-label="Patient Study Alert">
        <Typography fontSize={14} fontWeight="bold">
          This patient is apart of a clinical study.
        </Typography>
      </Alert>
    );
  }

  return null;
};

export default PatientStudiesAlert;
